import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 py-12 px-4 sm:px-6 lg:px-8 border-t border-navy-800 text-center" data-id="element-109">
      <div className="max-w-4xl mx-auto" data-id="element-110">
        <div className="text-2xl font-bold text-white mb-4" data-id="element-111">
          💙 MI MUNDO INTERIOR™
        </div>

        <p className="text-slate-400 mb-8 max-w-2xl mx-auto" data-id="element-112">
          El sistema de desarrollo emocional N°1 para adolescentes y sus
          familias.
          <br data-id="element-113" />
          <br data-id="element-114" />
          Porque acompañar a un adolescente no debería costarte todos los días
          del año sin saber qué hacer.
        </p>

        <div className="text-xs text-slate-500 space-y-2 mb-12" data-id="element-115">
          <p data-id="element-116">© Mi Mundo Interior™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-117">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <p className="text-sm font-medium text-blue-400/80 italic" data-id="element-118">
          💙 "El crecimiento emocional más importante no es el que se ve — es el
          que se construye adentro."
        </p>
      </div>
    </footer>;
}